import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useSelector } from 'react-redux';

//import images
import { Link } from 'react-router-dom';
import { createSelector } from 'reselect';

const ProfileDropdown = () => {

    const profiledropdownData = createSelector(
        (state: any) => state.Profile,
        (user) => user.user
    );
    // Inside your component
    const user = useSelector(profiledropdownData);

    const selectedCompany = useSelector((state: any) => state.Companies.selectedCompany);

    const [userName, setUserName] = useState("Admin");
    const [rolUser, setRolUser] = useState("Sin Rol");


    useEffect(() => {
        const authUser = localStorage.getItem("authUser");
        if (authUser) {
            try {
                const obj = JSON.parse(authUser);
                if (obj && obj.token) {
                    const base64Url = obj.token.split('.')[1];
                    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    }).join(''));

                    const decodedToken = JSON.parse(jsonPayload);
                    if (decodedToken && decodedToken.name) {
                        setUserName(decodedToken.name);
                        setRolUser(decodedToken.roles[0].name);
                    }
                } else if (obj && obj.name) {
                    setUserName(obj.name);
                }
            } catch (error) {
                console.error("Error decoding token:", error);
            }
        }
    }, [user]);

    //Dropdown Toggle
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    // Avatar: logo de empresa o primera letra del nombre
    const companyInitial = selectedCompany?.businessName?.charAt(0)?.toUpperCase() || '';
    const companyLogo = selectedCompany?.logoUrl;

    return (
        <React.Fragment>
            <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown}
                className="ms-sm-3 header-item topbar-user">
                <DropdownToggle tag="button" type="button" className="btn">
                    <span className="d-flex align-items-center">
                        <div
                            className="rounded-circle d-flex align-items-center justify-content-center overflow-hidden"
                            style={{
                                width: "35px",
                                height: "35px",
                                backgroundColor: companyLogo ? "transparent" : "#405189",
                                color: "#fff",
                                flexShrink: 0,
                            }}
                        >
                            {companyLogo ? (
                                <img
                                    src={companyLogo}
                                    alt={selectedCompany?.businessName || 'empresa'}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            ) : companyInitial ? (
                                <span style={{ fontSize: '16px', fontWeight: 700, lineHeight: 1 }}>
                                    {companyInitial}
                                </span>
                            ) : (
                                <i className="ri-user-3-line"></i>
                            )}
                        </div>

                        <span className="text-start ms-xl-2 d-flex flex-column">
                            <span className="d-none d-xl-inline-block fw-medium user-name-text">
                                {userName}
                            </span>
                            <span className="d-none d-xl-inline-block fs-12 text-muted">
                                {rolUser}
                            </span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Bienvenido: {userName}!</h6>
                    <DropdownItem className='p-0'>
                        <Link to="/logout" className="dropdown-item">
                            <i
                                className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                                    className="align-middle" data-key="t-logout">Cerrar sesión</span>
                        </Link>
                    </DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;
